module.exports = __webpack_public_path__ + "img/2019-07-01.fe9bc792.jpg";